import React from 'react';
import { Divider } from '@mui/material';

import Strings from '../../i18n';
import { ServerAccessMenuComponent } from '../../templates/ServerAccess/ServerAccessMenu/ServerAccessMenu.component';
import { TitleStyled } from '../devices/devicesStyles';

export const ServerAccessView = () => {
  return (
    <div>
      <TitleStyled>{Strings.serverAccess.pageTitle}</TitleStyled>
      <Divider variant="fullWidth" />
      <ServerAccessMenuComponent />
    </div>
  );
};
